import React from "react";
import styled from "@emotion/styled";
import Helper from "../functions/Helper.js";

const ResponsiveButton = styled.div((props) => ({
  "@media (max-width:576px)": {
    padding: "0.6rem 1.5rem",
    fontSize: 16,
  },
  display: "inline-block",
  cursor: "pointer",
  backgroundColor: "rgb(255, 90, 95)",
  textAlign: "center",
  color: "#fff",
  fontSize: 16,
  padding: "0.7rem 2rem",
  fontWeight: "bold!important",
  lineHeight: 1.5,
  borderRadius: 3,
  boxShadow: "0px 2px 6px 0px rgba(55,55,55,0.2)",
  ...props.style,
  "&:hover": {
    color: "#fff",
  },
  "&:focus": {
    color: "#fff",
  },
}));

const ResponsiveLink = ResponsiveButton.withComponent("a");

const getdataSetVars = (shoe, type) => {
  return {
    "data-shop":
      type === "new" ? shoe.new_offer.shop_name : shoe.resell_offer.shop_name,
    "data-price": shoe.discount,
    "data-list-price": shoe.price,
    "data-discount":
      type === "new"
        ? Math.round((1 - shoe.discount / shoe.price) * 100)
        : undefined,
    "data-product": shoe.shoe_name,
    "data-style-id": undefined,
    "data-style-name": undefined,
    "data-brand": shoe.brand,
  };
};

function BuyButton(props) {
  let discount = Math.round((1 - props.shoe.discount / props.shoe.price) * 100);

  if (props.shoe.new_offer.shops > 1) {
    return (
      <>
        <div style={{ marginBottom: 2 }}>
          {discount > 0 ? (
            <span style={{ fontSize: 16, textDecorationLine: "line-through" }}>
              ${Math.round(props.shoe.price)}
            </span>
          ) : (
            <span style={{ fontSize: 16 }}>from</span>
          )}
          <span
            style={{
              marginLeft: 5,
              fontSize: 20,
              fontWeight: "bold",
              ...props.priceStyle,
            }}
          >
            ${Number(props.shoe.discount).toFixed(2)}
          </span>
        </div>
        <ResponsiveButton
          onMouseEnter={props.onMouseEnter}
          style={props.style}
          onClick={props.onClick}
        >
          <i className="fas fa-shopping-cart" style={{ marginRight: 10 }}></i>
          Buy from {props.shoe.new_offer.shops} Shops
        </ResponsiveButton>
      </>
    );
  } else if (props.shoe.new_offer.shops === 1) {
    return (
      <>
        <div style={{ marginBottom: 5 }}>
          {discount > 0 ? (
            <span style={{ fontSize: 16, textDecorationLine: "line-through" }}>
              ${Math.round(props.shoe.price)}
            </span>
          ) : (
            <span style={{ fontSize: 16 }}>from</span>
          )}
          <span
            style={{
              marginLeft: 5,
              fontSize: 22,
              fontWeight: "bold",
              ...props.priceStyle,
            }}
          >
            ${Number(props.shoe.discount).toFixed(2)}
          </span>
        </div>
        <ResponsiveLink
          style={props.style}
          target="_blank"
          rel="noopener noreferrer nofollow"
          data-tracking-id={props.linkId}
          {...getdataSetVars(props.shoe, "new")}
          href={Helper.insert_link(
            props.shoe.new_offer.url,
            props.linkId,
            props.shoe.new_offer.tracking_id
          )}
        >
          <i style={{ marginRight: "10px" }} className="fas fa-shopping-cart" />
          Buy from {props.shoe.new_offer.shop_name}
        </ResponsiveLink>
      </>
    );
  } else if (props.shoe.resell_offer.shops > 0) {
    return (
      <>
        <div style={{ marginBottom: 5 }}>
          <span style={{ fontSize: 16 }}>from</span>
          <span
            style={{
              marginLeft: 5,
              fontSize: 22,
              fontWeight: "bold",
              ...props.priceStyle,
            }}
          >
            ${Number(props.shoe.resell_price).toFixed(2)}
          </span>
        </div>
        <ResponsiveLink
          data-tracking-id={props.linkId}
          {...getdataSetVars(props.shoe, "resell")}
          style={props.style}
          target="_blank"
          rel="noopener noreferrer nofollow"
          href={Helper.insert_link(
            props.shoe.resell_offer.url,
            props.linkId,
            props.shoe.resell_offer.tracking_id
          )}
        >
          <i style={{ marginRight: "10px" }} className="fas fa-shopping-cart" />
          Buy from {props.shoe.resell_offer.shop_name}
        </ResponsiveLink>
      </>
    );
  } else {
    return null;
  }
}

export default BuyButton;
